import { getSpuIdsFromCMS } from './service'
/**
 * @returns {Promise<Array>}
 */
export async function removeSpuIds(spuList: Array<any>) {
  const data = await getSpuIdsFromCMS()
  
  const childBirthSerivePackageList = data.spuIds
  const status = !!+data.status
  // 关闭待产包
  if (!status) return spuList
  
  return spuList.filter(x => !childBirthSerivePackageList.includes(x.spuId))
}
